var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"progressbar"},[_c('LvProgressBar',{attrs:{"mode":"indeterminate"}}),_c('br'),_c('div',{staticClass:"text-center button"},[_vm._v("LOADING DATA...")]),_c('br'),_c('LvProgressBar',{attrs:{"mode":"indeterminate","color":"#38b2ac"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }